export function getDataTableCustomStyles() {
  return {
    table: {
      style: {
        backgroundColor: "var(--card-bg)",
        color: "var(--text-color)",
      },
    },
    headRow: {
      style: {
        backgroundColor: "var(--table-header-bg)",
        borderBottomColor: "var(--border-color)",
        minHeight: "48px",
      },
    },
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "var(--text-color)",
        backgroundColor: "var(--table-header-bg)",
      },
    },
    rows: {
      style: {
        backgroundColor: "var(--card-bg)",
        color: "var(--text-color)",
        borderBottomColor: "var(--border-color)",
        minHeight: "48px",
      },
      highlightOnHoverStyle: {
        backgroundColor: "var(--surface-bg)",
        color: "var(--text-color)",
      },
    },
    cells: {
      style: {
        color: "var(--text-color)",
      },
    },
    pagination: {
      style: {
        backgroundColor: "var(--card-bg)",
        color: "var(--text-color)",
        borderTopColor: "var(--border-color)",
      },
      pageButtonsStyle: {
        color: "var(--text-color)",
        fill: "var(--text-color)",
        backgroundColor: "transparent",
        "&:disabled": {
          color: "var(--text-muted)",
          fill: "var(--text-muted)",
          backgroundColor: "var(--input-bg)",
        },
        "&:hover:not(:disabled)": {
          backgroundColor: "var(--surface-bg)",
        },
      },
    },
    noData: {
      style: {
        backgroundColor: "var(--card-bg)",
        color: "var(--text-muted)",
      },
    },
  };
}
